<!-- <p>asset-comparison works!</p> -->
<div class="main-comparison-div">
    <span style="font-size: larger; font-weight: bolder;">Compare Assets</span>
    <div class="middle-div alignRow">
        <button mat-raised-button style="margin-right: 1em;" color="primary" (click)="compare()">Compare</button>
        <div class="switch-div alignRow">
            <mat-slide-toggle color="primary" (change)="chartOnlyChange($event.checked)"
                [checked]="defaultValue"></mat-slide-toggle>
            <span>Charted Datapoints Only</span>
        </div>
        <div class="SI-container alignRow" *ngIf="comparingAssets.length > 0">
            <div class="SI-div alignRow" *ngFor="let si of datapointSIs">
                <mat-checkbox id="{{si.SI}}" #siCheckbox color="primary"
                    (change)="toggleSICheckbox($event, si.SI)"></mat-checkbox>
                <span class="datapoint-title">{{si.SI}}</span>
            </div>
        </div>
        <span class="toolbar-spacer"></span>
        <mat-icon style="cursor: pointer;" *ngIf="selectedLocation"
            (click)="filterByLocation($event, true)">close</mat-icon>
        <div class="location-dropdown">
            <ejs-dropdownlist id="dropdown" #dropdown [dataSource]='MainLocations' placeholder="Select Location"
                [fields]="locationFields" (change)="filterByLocation($event)" [allowFiltering]="true"
                filterType="contains">
                <ng-template #itemTemplate let-data>
                    <div>
                        <span>{{ data.Name }}</span>
                    </div>
                </ng-template>
            </ejs-dropdownlist>
        </div>
    </div>
    <div class="selection-container"
        [ngStyle]="{'grid-template-columns': '1fr '.repeat((this.comparingAssets.length + 1) <= 5 ? this.comparingAssets.length + 1 : 5)}">
        <div
            *ngFor="let i of [].constructor((comparingAssets.length + 1) <= 5 ? comparingAssets.length + 1 : 5) let idx = index">
            <div class="selection-div">
                <mat-form-field>
                    <mat-label>Search for an Asset</mat-label>
                    <input matInput (keyup)="onFilteringAssets($event, idx)" placeholder="Search" #input>
                </mat-form-field>
                <div class="alignRow alignColumn" [ngClass]="comparingAssets[idx] ? 'dropdown-cancel':'dropdown'">
                    <ejs-dropdownlist id="{{idx}}" #assetDropdown [dataSource]='filteredAssetList1'
                        placeholder="Select Asset" [fields]="assetFields" (change)="selectAsset($event, idx)">
                        <ng-template #itemTemplate let-data>
                            <div>
                                <span>{{ data.Name }} - {{ data.Description }}</span>
                            </div>
                        </ng-template>
                    </ejs-dropdownlist>
                    <span class="app-icon app-icon--close cancel-button" *ngIf="comparingAssets[idx]"
                        (click)="clearSelection(idx)"><mat-icon /></span>
                </div>
            </div>
            <div class="asset-details" *ngIf="comparingAssets[idx]">
                <div class="alignRow alignColumn">
                    <img width="100%" height="100px" style="border-radius: var(--default-border-radius);"
                        (click)="viewImage(imagePathAssets() + comparingAssets[idx].AssetID + '?' + comparingAssets[idx].Modified)"
                        src="{{imagePathAssets()}}{{comparingAssets[idx].AssetID}}?{{comparingAssets[idx].Modified}}"
                        alt="{{comparingAssets[idx].Name}}"
                        onerror="this.src='https://stmgwebappstorage.blob.core.windows.net/prismpdm/assets/noimage.png'" />
                </div>
                <div class="details-section">
                    <span>Name:</span>
                    <span><b>{{ comparingAssets[idx].Name }}</b></span>
                    <span>Description:</span>
                    <span><b>{{ comparingAssets[idx].Description }}</b></span>
                </div>
                <div class="functional-location-button">
                    <button mat-raised-button color="primary" (click)="goToFunctionalLocation(comparingAssets[idx])" class="app-icon--goto">
                        <mat-icon/>
                        <span>Functional Location</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
    <div class="chart-container" *ngIf="comparingAssets.length > 0">
        <div class="chart-details" *ngIf="assetDataPoints.length > 0"
            [ngStyle]="{'grid-template-columns': '1fr '.repeat((this.assetDataPoints.length + 1) <= 5 ? this.assetDataPoints.length + 1 : 5)}">
            <div class="datapoint-list" *ngFor="let list of assetDataPoints">
                <ng-container *ngFor="let datapoint of list">
                    <div class="datapoint-div alignRow" *ngIf="!(datapoint.IsCumulative && datapoint.ShowDeltaValue)">
                        <mat-checkbox id="{{datapoint.DataPointID}}" #datapointCheckbox color="primary"
                            (change)="toggleCheckbox($event, datapoint)"></mat-checkbox>
                        <span class="colour-box" [style.background-color]="getColor(datapoint)"></span>
                        <span class="datapoint-title" title="{{datapoint.DPTitle}}">{{ datapoint.DPTitle }}</span>
                    </div>
                </ng-container>
            </div>
        </div>
        <div class="chart-div alignColumn alignRow">
            <div class="graph alignColumn alignRow">
                <ejs-chart style="width: 100%; height: 100%;" #myChart2 id="myChart2" [primaryXAxis]='sensorXAxis'
                    [zoomSettings]="zoomSettings" [legendSettings]='legend' [tooltip]='tooltipSettings'
                    [crosshair]='crosshair' background="#FFFFFF" [border]="borderSettings"
                    [selectionMode]=' selectionMode' [palettes]='palette' (legendClick)="legendClick($event)"
                    (zoomComplete)="onZoom($event)" (scrollChanged)="onScroll($event)"
                    (chartMouseDown)="checkClick($event)" (tooltipRender)="onTooltipRender($event)">
                </ejs-chart>
                <!-- (seriesRender)="checkAllSIEnabled()" -->
                <!-- Spinner -->
                <div class="local-spinner" *ngIf="spinner">
                    <img src="https://stmgwebappstorage.blob.core.windows.net/prismpdm/assets/loading.gif"
                        [attr.x-contenttype]="'image/gif'" alt="Loading..." />
                </div>
            </div>
            <span *ngIf="visibleStartDate && visibleEndDate"
                matTooltip="{{getShortDate(visibleStartDate)}} - {{getShortDate(visibleEndDate)}}"
                class="hideoverflow">{{getShortDate(visibleStartDate)}} - {{getShortDate(visibleEndDate)}}
            </span>
            <div class="noshrink alignRow">
                <mat-icon matTooltip="Navigate Backwards" (click)="navigateByDuration(false)">chevron_left</mat-icon>

                <app-duration-selector [(duration)]="strDuration"
                    (durationChange)="selectTime($event)"></app-duration-selector>

                <mat-icon matTooltip="Navigate Forwards" (click)="navigateByDuration(true)">chevron_right</mat-icon>

                <span mat-icon-button [matMenuTriggerFor]="timeMenu" #timeTrigger="matMenuTrigger"
                    style="margin-left: 10px;" class="alignRow" matTooltip="Date Range">
                    <mat-icon>access_time</mat-icon>
                </span>
                <span class="me-auto"></span>

                <mat-menu #timeMenu="matMenu">
                    <div style="margin: 1em;">
                        <app-date-range-picker (datePickerChange)="DatePickerChange($event)"
                            [matMenuTrigger]="timeTrigger"></app-date-range-picker>
                    </div>
                </mat-menu>
            </div>
            <button *ngIf="includesCumulativeDatapoints" mat-icon-button class="graph-button"
                (click)="toggleShowBars($event)">
                <mat-icon>{{showBars ? "show_chart" : "bar_chart"}}</mat-icon>
            </button>
        </div>
    </div>
    <div class="statistics-div" *ngIf="statistics.length > 0">
        <!-- <span style="font-size: larger; font-weight: bolder;">Statistics</span> -->
        <div class="statistics-item" style="border-top: 0px !important;">
            <span>Datapoint</span>
            <span>Max</span>
            <span>Min</span>
            <span>Average</span>
            <span>Sample Count</span>
        </div>
        <div class="statistics-list">
            <div class="statistics-item" *ngFor="let data of filteredStatistics">
                <span>{{data.datapoint.DPTitle}}</span>
                <span>{{data.max}}{{data.datapoint.SI}}</span>
                <span>{{data.min}}{{data.datapoint.SI}}</span>
                <span>{{data.average}}{{data.datapoint.SI}}</span>
                <span>{{data.sampleCount}}</span>
            </div>
        </div>
    </div>
    <div class="statistics-div" *ngIf="cumulativeStatistics.length > 0 && includesCumulativeDatapoints">
        <!-- <span style="font-size: larger; font-weight: bolder;">Statistics</span> -->
        <div class="statistics-item" style="border-top: 0px !important;">
            <span>Datapoint</span>
            <span>Start</span>
            <span>End</span>
            <span>Usage</span>
            <span>Sample Count</span>
        </div>
        <div class="statistics-list">
            <div class="statistics-item" *ngFor="let data of cumulativeStatistics">
                <span>{{data.datapoint.DPTitle}}</span>
                <span>{{data.min}}{{data.datapoint.SI}}</span>
                <span>{{data.max}}{{data.datapoint.SI}}</span>
                <span>{{data.difference}}{{data.datapoint.SI}}</span>
                <span>{{data.sampleCount}}</span>
            </div>
        </div>
    </div>
</div>